var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronDownBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons / system / info") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artwork",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LandingPage-RailcardRetailing-1440",
    transform: "translate(-1064, -4309)",
    fill: "#0085FF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FAQs",
    transform: "translate(0, 3798)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Question-2",
    transform: "translate(344, 511)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-/-system-/-info",
    transform: "translate(728.5567, 11.9967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6166667,0.39 L7.44333333,5.56333333 L2.27,0.39 C1.75,-0.13 0.91,-0.13 0.39,0.39 C-0.13,0.91 -0.13,1.75 0.39,2.27 L6.51,8.39 C7.03,8.91 7.87,8.91 8.39,8.39 L14.51,2.27 C15.03,1.75 15.03,0.91 14.51,0.39 C13.99,-0.116666667 13.1366667,-0.13 12.6166667,0.39 L12.6166667,0.39 Z",
    id: "icon"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownBlue);
export default __webpack_public_path__ + "static/media/chevron-down-blue.a67467e9e9e681088f9fc6ff2b04b482.svg";
export { ForwardRef as ReactComponent };